﻿import { Component, OnInit } from '@angular/core';
import { RestService } from 'src/app/_services/rest.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from 'src/app/_services';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Pedido, Item, Lista } from 'src/app/_models';
import { GoogleAnalyticsService } from 'src/app/_services/analytics.service';



@Component({ templateUrl: 'resumen.regalos.component.html' })
export class ResumenRegalosComponent implements OnInit {

    nombre: string;
    codigo: string;
    idLista: number;
    pedido: Pedido;
    finalizarForm: FormGroup;
    loading = false;
    submitted = false;
    mercadoPago: boolean = false;
    monetizada: boolean = false;
    anonima: boolean = false;

    constructor(
        private restService: RestService,
        private route: ActivatedRoute,
        private router: Router,
        private alertService: AlertService,
        private googleAnalyticsService: GoogleAnalyticsService,
        private formBuilder: FormBuilder) {
        // this.ngOnInit();
    }


    ngOnInit() {

        this.route.queryParams.subscribe(params => {
            if (params['pedido']) {
                this.pedido = new Pedido();
                const temp: Pedido = JSON.parse(params['pedido']);
                for (let item of temp.items) {
                    this.pedido.items.push(new Item(item.producto, item.cantidad));
                };
            }
            if (params['nombre']) {
                this.nombre = params['nombre'];
            } else {
                this.nombre = null;
            }
            if (params['codigo']) {
                this.codigo = params['codigo'];
            } else {
                this.codigo = null;
            }
            if (params['idLista']) {
                this.idLista = params['idLista'];
            } else {
                this.idLista = null;
            }
            if (params['monetizada']) {
                this.monetizada = params['monetizada'];
            } else {
                this.monetizada = false;
            }
            if (params['anonima']) {
                this.anonima = params['anonima'].toUpperCase() === 'TRUE';
            } else {
                this.anonima = false;
            }
        });
        this.restService.getParam('mercadolibre').subscribe(data => {
            this.mercadoPago = data.valor.toString().toUpperCase() === 'TRUE';
        });
        this.finalizarForm = this.formBuilder.group({
            name: ['', Validators.required],
            mensaje: ['', Validators.required]
        });
    }

    volver() {
        let param: any;
        if (this.anonima) {
            param = { anonima: true };
            this.googleAnalyticsService.eventEmitter("ecommerce", 'anonima', 'deshacer' );
        } else {
            param = { nombre: this.nombre, codigo: this.codigo }
            this.googleAnalyticsService.eventEmitter("ecommerce", this.nombre, 'deshacer');
        }
        this.router.navigate(['/elegir'], { queryParams: param });
    }

    // private esMonetizada(): boolean {
    //     return this.mercadoPago && this.monetizada;
    // }


    // convenience getter for easy access to form fields
    get f() { return this.finalizarForm.controls; }

    onSubmit() {
        this.submitted = true;

        if (this.finalizarForm.invalid) {
            return;
        }
        this.loading = true;
        this.pedido.de = this.f.name.value
        this.pedido.mensaje = this.f.mensaje.value
        this.restService.post('/rest-api/public/pedido', { pedido: this.pedido, idLista: this.idLista }).subscribe(
            data => {
                window.location.href = data.url;
            },
            error => {
                this.alertService.error(error);
                this.loading = false;
            });
    }


    /**
     * esto es para regalar a gente, sin lista, 
     * se activa con parametro regalo.anonimo
     * @returns 
     */
    onSubmitAnonimo() {
        this.submitted = true;

        if (this.finalizarForm.invalid) {
            return;
        }
        this.loading = true;
        this.pedido.de = this.f.name.value
        this.pedido.mensaje = this.f.mensaje.value
        this.createLink();
    }



    private link(): string {
        const tmp: any = {};
        tmp['de'] = this.pedido.de;
        tmp['mensaje'] = this.pedido.mensaje;
        const items: any = [];
        this.pedido.items.forEach(item => {
            items.push({ cantidad: item.cantidad, producto: { id: item.producto.id } })
        });
        tmp['items'] = items;
        let keys: string = ''
        const txt = window.btoa(JSON.stringify(tmp));
        const index = document.location.href.toString().indexOf('/resumen');
        return document.location.href.toString().substr(0, index) + '/regalo?code=' + txt;
    }

    linkWS(): string {
        return 'https://wa.me/?text=' + encodeURIComponent(this.link());
    }


    createLink() {
        let a = document.createElement('a');
        a.style.position = 'fixed';
        a.style.left = '0';
        a.style.top = '0';
        a.style.opacity = '0';
        a.target = 'blank';
        a.href = this.linkWS();
        a.click();
    }
}

